import $ from "jquery";
import _ from "lodash";
import { autoUpdate, computePosition, flip, offset, shift, arrow as floatingArrow, } from "@floating-ui/dom";
import { cloneableFactory } from "./cloneable";
import { modal, modalContentSelector } from "./modal";
import { subscribe } from "../events/jQuerySubscription";
class Popover {
    constructor(trigger) {
        this.hoverTimeoutStarted = false;
        this.trigger = trigger;
        //Don't remove the original popover, or cloneable.ts won't work.
        //Set to display: none to remove it from the flow.
        this.popover = $(this.trigger.data("popover"))
            .css({ display: "none" })
            .clone()
            .css({ display: "" });
        this.arrow = this.popover.find(".arrow");
        this.placement = this.trigger.data("popover-placement") || "right";
        let popoverContainer = this.trigger.closest(modalContentSelector);
        if (!_.some(popoverContainer))
            popoverContainer = $("body");
        popoverContainer.append(this.popover);
        if (this.trigger.is("[data-popover-hover]")) {
            this.setUpHover();
            this.setUpAction();
        }
    }
    show(hideTimeout = 2000) {
        const stopPositionAutoUpdate = this.autoUpdatePosition();
        this.popover.addClass("popover-visible");
        setTimeout(() => {
            this.hideInternal();
            stopPositionAutoUpdate();
        }, hideTimeout);
    }
    setUpHover() {
        this.trigger.on("mouseenter", async () => {
            this.hoverTimeoutStarted = true;
            const timeout = setTimeout(() => {
                clearTimeout(timeout);
                this.hoverTimeoutStarted && this.showInternal();
            }, 300);
            const subscriptions = [
                subscribe(this.trigger, "mouseleave", () => checkMousePosition()),
                subscribe(this.popover, "mouseleave", () => checkMousePosition()),
            ];
            const checkMousePosition = () => {
                clearTimeout(timeout);
                if (this.hoverTimeoutStarted) {
                    setTimeout(() => {
                        if (!_.some(this.trigger.filter(":hover")) &&
                            !_.some(this.popover.filter(":hover"))) {
                            this.hideInternal();
                            this.hoverTimeoutStarted = false;
                            subscriptions.forEach((s) => s.off());
                        }
                    }, 100);
                }
            };
        });
    }
    setUpAction() {
        this.trigger.on("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hoverTimeoutStarted = false;
            this.toggle();
        });
        $(document).on("click", (e) => {
            if (e.currentTarget === this.popover[0] ||
                _.some(this.popover.has(e.currentTarget)))
                return;
            this.hideInternal();
        });
        $(document).on("keydown", ({ key }) => {
            if (key === "Enter" || key === " ") {
                const triggerHasFocus = this.trigger[0] === document.activeElement ||
                    (document.activeElement &&
                        _.some(this.trigger.has(document.activeElement)));
                triggerHasFocus && this.toggle();
            }
            if (key === "Escape" || key === "Tab")
                this.hideInternal();
        });
    }
    toggle() {
        if (this.popover.hasClass("popover-visible")) {
            this.hideInternal();
        }
        else {
            this.showInternal();
        }
    }
    showInternal() {
        this.popover.addClass("popover-visible");
        this.position();
    }
    hideInternal() {
        this.popover.removeClass("popover-visible");
    }
    autoUpdatePosition() {
        return autoUpdate(this.trigger[0], this.popover[0], () => this.position(), {
            animationFrame: true,
        });
    }
    async position() {
        var _a, _b, _c, _d;
        const { x, y, placement: arrowPlacement, middlewareData, } = await computePosition(this.trigger[0], this.popover[0], {
            placement: this.placement,
            middleware: [
                offset(_.some(this.arrow) ? 10 : 8),
                flip({
                    fallbackAxisSideDirection: "start",
                }),
                shift({ padding: 5 }),
                floatingArrow({ element: this.arrow[0] }),
            ],
        });
        this.popover.css({
            left: `${x}px`,
            top: `${y}px`,
        });
        const arrowSide = arrowPlacement.split("-")[0];
        const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right",
        }[arrowSide];
        this.arrow.css({
            left: ((_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) != undefined
                ? `${(_b = middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.x}px`
                : "",
            top: ((_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) != undefined
                ? `${(_d = middlewareData.arrow) === null || _d === void 0 ? void 0 : _d.y}px`
                : "",
            right: "",
            bottom: "",
            [staticSide]: "-6px",
        });
    }
}
class PopoverFactory {
    initialise(container) {
        const triggers = $(container).find("[data-popover]");
        triggers.toArray().forEach((t) => {
            const trigger = $(t);
            if (!trigger.data("popover-model"))
                trigger.data("popover-model", new Popover(trigger));
        });
    }
    getModels(triggers) {
        return triggers
            .toArray()
            .map((t) => {
            const trigger = $(t);
            return trigger.data("popover-model");
        })
            .filter((m) => !!m);
    }
}
export const popoverFactory = new PopoverFactory();
$(() => popoverFactory.initialise(document));
modal.on("show", (m) => popoverFactory.initialise(m));
cloneableFactory.on("itemAdded", (i) => popoverFactory.initialise(i));
